<template>
  <div id="appleRecharge"></div>
</template>
<script>
import { mapGetters } from 'vuex'
// import FN from '@/utility/fn.js'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['rechargeAges'])
  },
  mounted () {
    this.applePay(this.rechargeAges)
  },
  methods: {
    applePay (data) {
      // cp点击购买,触发请求得到支付的链接
      // let _this = this
      let { order_id, product_id } = data

      // 不切支付,使用苹果内购,需要传参数给ios客户端进行拉起内购
      let user_id = JSON.parse(sessionStorage.getItem('USER_INFO')).user_id // 用户id
      let os = JSON.parse(sessionStorage.getItem('FUSE_CHANNEL_INFO')).os // 系统,由后台指定
      let channel = JSON.parse(sessionStorage.getItem('FUSE_CHANNEL_INFO')).channel // 渠道
      let game_name = JSON.parse(sessionStorage.getItem('FUSE_CHANNEL_INFO')).game_name // 游戏名称
      let game_id = JSON.parse(sessionStorage.getItem('FUSE_CHANNEL_INFO')).game_id // 游戏ID
      let package_id = JSON.parse(sessionStorage.getItem('h5sdk')).package_id // 游戏包ID
      let version = '1.0'
      let platform_version = '1.0'
      // alert('product_id: ' + product_id)
      // 判断是否存在product_id 苹果内购id
      if (product_id) {
        // 如果存在,则拉起内购
        let isoOrderInfo = `{"product_id":"${product_id}","order_id":"${order_id}","version": "1.2","user_id":"${user_id}","os":"${os}","channel":"${channel}","game_id":"${game_id}","game_name":"${game_name}","package_id":"${package_id}","version":"${version}","platform_version":"${platform_version}"}`
        // 发送信息给ios客户端
        // alert('发送信息给IOS客户端,拉起内购')
        // alert(isoOrderInfo)
        this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
        window.webkit.messageHandlers.wb_ios.postMessage(isoOrderInfo)
      }
    }
  }
}

</script>
<style lang="scss" scoped>

</style>
